<template>
  <div class="auth-layout">
    <div class="nav d-lg-none">
      <div class="auth-layout-mobile">
        <router-link :to="{path: '/'}">
          <vuestic-icon-vuestic-login-mobile/>
        </router-link>
      </div>
    </div>
    
    <div class="main row">
      <div class="auth-content flex lg6 xs12 fill-height">
        <div class="flex-center">
          <router-view/>
        </div>
      </div>

      <div class="auth-layout__auth-wallpaper flex md6">
        <div class="flex-center">
          <div class="auth-layout__auth-wallpaper__cross-line"/>
          <div class="auth-layout-desktop">
            <router-link class="auth-layout__auth-wallpaper__logo" :to="{path: '/sp360'}">
              <vuestic-icon-vuestic-login/>
            </router-link>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

import VuesticIconVuesticLogin
  from '../../vuestic-theme/vuestic-components/icon/VuesticIconVuesticLogin'
import VuesticIconVuesticLoginMobile
  from '../../vuestic-theme/vuestic-components/icon/VuesticIconVuesticLoginMobile'

export default {
  name: 'AuthLayout',
  components: { VuesticIconVuesticLogin, VuesticIconVuesticLoginMobile },
}
</script>

<style lang="scss">
$auth-wallpaper-ivuestic-h: 2.625rem;
$auth-wallpaper-ivuestic-composto-h: 14.625rem;
$auth-wallpaper-oblique-line: $dark-gray;
$top-mobile-nav-height: 6.5rem;
$layout-mobile-padding: 0.1875rem;
$layout-mobile-padding-right: .375rem;
$auth-mobile-nav-ivuestic-h: 1.5rem;
$auth-mobile-main-h: calc(100% - #{$top-mobile-nav-height});
$auth-content-padding-t: 2.875rem;

.auth-layout {
  height: 100vh;
  margin: 0;

  &__auth-wallpaper {
    position: relative;
    background-color: $black-pearl;
    overflow: hidden;
    @include va-flex-center();
    &__logo {
      z-index: 2;
      position: absolute;
      height: $auth-wallpaper-ivuestic-composto-h;
      width: 100%;
    }
    .vuestic-icon-vuestic {
      height: $auth-wallpaper-ivuestic-composto-h;
      width: 100%;
    }

    &__cross-line {
      z-index: 1;
      position: absolute;
      background-color: $auth-wallpaper-oblique-line;
      left: calc(50% - 27% / 2);
      transform: rotate(15deg);
      width: 27%;
      height: 115%;
    }
  }

  .nav {
    display: flex;
    align-items: center;
    justify-content: center;
    height: $top-mobile-nav-height;
    background-color: $black-pearl;
    .vuestic-icon-vuestic {
      height: $auth-mobile-nav-ivuestic-h;
      width: 100%;
    }
  }
  .main {
    margin: 0;
    height: 100vh;
    .auth-content {
      padding: 0;
      display: flex;
      align-items: center;
      justify-content: center;
      background-color: white;
    }
  }

  @include media-breakpoint-down(md) {
    .main {
      height: $auth-mobile-main-h;
      .auth-content {
        align-items: flex-start;
        padding-top: $auth-content-padding-t;
      }
      .auth-wallpaper {
        display: none;
      }
    }
  }
}

@media (min-width: 992px){
  .d-lg-none {
      display: none!important;
  }
}

.auth-layout-mobile{
  display:flex;
  justify-content:center;
  align-items:center;
  margin: auto;
}

.auth-layout-desktop{
  display:flex;
  justify-content:center;
  align-items:center;
  margin-left: 50%;
}

</style>
